import React, { useContext, useEffect } from 'react';
import { DispositionModule } from '../../DispositionModule/index';
import { SearchStore } from '../../SearchStore/index';
import { setLocalisationFinishAnalyticsData } from 'common/utilities/analyticsUtils';
import START_ORDER_CONSTANTS from '../../StartOrderComponent/Constants/startOrderConstants';
import { UserOrderContext } from '../../../context/context';
import { ScheduleOrder } from '../../ScheduleOrder';

export const UserLocalizationComponent = props => {
  const { DISPOSITION_DATA = '' } = START_ORDER_CONSTANTS;
  const { userOrderState, userOrderStateDispatch } = useContext(UserOrderContext) || {};

  /**
   * Method to open open disposition module
   */
  useEffect(() => {
    userOrderStateDispatch({ type: DISPOSITION_DATA, value: { showDisposition: true } });
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <React.Fragment>
      <div id='startorder-container' data-testid='UserLocalizationComponent-component'>
        {userOrderState?.dispositionStateData.showDisposition && <DispositionModule />}
        {userOrderState?.searchStoreData.showSearchStore && (
          <SearchStore onStoreSelectFinish={setLocalisationFinishAnalyticsData} />
        )}
        {userOrderState?.scheduleOrderData.showScheduleOrderCatering && (
          <ScheduleOrder onStoreSelectFinish={setLocalisationFinishAnalyticsData} />
        )}
      </div>
    </React.Fragment>
  );
};

export default UserLocalizationComponent;
